<mat-form-field>
    <mat-label>{{ "posts.filters.author.label" | translate }}</mat-label>
    <input
      type="text"
      matInput
      [(ngModel)]="selectedUser"
      [formControl]="userSearchContol"
      [matAutocomplete]="auto"
      />
    <button *ngIf="selectedUser" matSuffix mat-icon-button aria-label="Clear" (click)="clearSelection()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="onUserSelected($event.option.value)">
      <mat-option *ngIf="loading" class="is-loading">Loading...</mat-option>
      <ng-container *ngIf="!loading">
        <mat-option *ngFor="let user of filteredOptions" [value]="user">
          <span>
            {{ user.displayNameString }} ({{user.username}}) {{user.admin?'*':''}}</span>
        </mat-option>
      </ng-container>
    </mat-autocomplete>
  </mat-form-field>